import type { EquityPoint } from "../api/types";
import { fmtKst, fmtNumber } from "../lib/format";
import { EmptyState } from "./ui/Primitives";
/** Time coordinates and null observations preserve gaps. All y values are observed. */
export default function EquityChart({ points }: {
    points: EquityPoint[];
}) {
    const good = points.filter(p => p.equity != null);
    if (!good.length)
        return <EmptyState title="자산 추이를 확인할 기록이 부족합니다"/>;
    const values = good.map(p => p.equity!);
    const low = Math.min(...values), high = Math.max(...values);
    const padding = Math.max((high - low) * .12, 1);
    const start = Date.parse(points[0].ts), end = Date.parse(points[points.length - 1].ts);
    const x = (at: string) => 65 + (Date.parse(at) - start) / Math.max(1, end - start) * 680;
    const y = (value: number) => 180 - (value - low + padding) / (high - low + padding * 2) * 150;
    let pen = false;
    const line = points.map(p => {
        if (p.equity == null) {
            pen = false;
            return "";
        }
        const text = `${pen ? "L" : "M"} ${x(p.ts)} ${y(p.equity)}`;
        pen = true;
        return text;
    }).join(" ");
    return <figure className="research-chart"><svg viewBox="0 0 800 220" role="img" aria-label="C1 평가 자산. 누락 구간은 선을 연결하지 않습니다.">
    <title>C1 평가 자산 · USDT</title>
    {[low, (low + high) / 2, high].filter((v, i, a) => a.indexOf(v) === i).map(v => <g key={v}>
      <line x1="65" x2="745" y1={y(v)} y2={y(v)} className="chart-reference"/>
      <text x="60" y={y(v) + 4} textAnchor="end">{fmtNumber(v, { digits: 1 })}</text>
    </g>)}
    <path d={line} fill="none" className="chart-baseline-line"/>
    {good.length === 1 && <circle cx={x(good[0].ts)} cy={y(good[0].equity!)} r="4" className="chart-baseline-line"/>}
    <text x="65" y="210">{fmtKst(points[0].ts, { seconds: false })}</text>
    <text x="745" y="210" textAnchor="end">{fmtKst(points[points.length - 1].ts, { seconds: false })}</text>
  </svg><figcaption>실제 관측 · USDT · 누락 구간은 연결하지 않습니다</figcaption></figure>;
}
